<template>
  <div class="managerNetworkSearchFilter">
    <div class="managerNetworkSearchFilter__firstSection">
      <div class="managerNetworkSearchFilter__firstSection__leftSection">
        <router-link to="./networkSearch" class="btn-router">
          기업회원 검색
        </router-link>

        <router-link to="./individualMemberSearch" class="btn-router">
          개인회원 검색
        </router-link>
      </div>

      <div class="managerNetworkSearchFilter__firstSection__rightSection">
        <div class="searchInput">
          <input type="text" placeholder="기업명을 입력하세요." />
        </div>
        <MainButton btnText="검색" width="74px" fontSize="18px" />
        <MainButton btnText="초기화" width="92px" fontSize="18px" color="red" />
      </div>
    </div>

    <div class="managerNetworkSearchFilter__lastSection">
      <div style="flex:1">
        <SelectOption
          :options="options"
          :handleChangeOption="handleChangeOption"
          textHelper="*10대 시니어산업군별 기업 검색"
          width="100%"
        />
      </div>
      <div style="border-left: 1px solid #D6D6D6;"></div>
      <div style="flex: 1;">
        <SelectOption
          :options="options"
          :handleChangeOption="handleChangeOption"
          textHelper="*고령친화 비즈니스 목표별 검색"
          width="100%"
        />
      </div>
      <div style="border-left: 1px solid #D6D6D6;"></div>
      <div
        class="right-option"
        style="flex: 1; display: flex; gap: 2rem; width: 100%;"
      >
        <SelectOption
          :options="options"
          :handleChangeOption="handleChangeOption"
          width="100%"
        />
        <div>
          <button class="btn-solid">검색</button>
          <button class="btn-outlined">초기화</button>
        </div>
      </div>
    </div>

    <div style="display: flex; justify-content: center; padding-top: 24px;">
      <button class="btn-reset-filter">전체 검색 초기화</button>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import SelectOption from "@/components/formControl/SelectOption.vue";

export default {
  name: "NetworkSearchFilter",
  components: { MainButton, SelectOption },
  data() {
    return {
      selected: null,
      currentRoute: "",
      options: [
        { value: null, text: "매치메이킹 희망 분야" },
        { value: "a", text: "매치메이킹 희망 분야" },
        { value: "b", text: "매치메이킹 희망 분야" },
      ],
    };
  },

  mounted() {
    this.currentRoute = this?.$router?.currentRoute?.fullPath;

    console.log(this?.$router?.currentRoute?.fullPath, this.currentRoute);
  },

  methods: {
    // Handle change of selected
    handleChangeOption(value) {
      this.selected = value;
    },
  },
};
</script>

<style scoped lang="scss">
.btn-router {
  white-space: nowrap;
  width: 200px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border-radius: 4px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: -0.05em;
  color: #a6a6a6;
  height: 46px;
}

.router-link-active {
  background: #26336a;
  color: #fff;
}
</style>
